import React, { useContext, useState, useRef } from 'react';
import { Container, Table, Spinner, Form, Row, Col, InputGroup, Button } from 'react-bootstrap';
import $ from 'jquery';
import ReactToPrint from "react-to-print";
import generatePDF from 'react-to-pdf';
import { AppContext } from '../App';


export const ServiceReport = () => {
	const { getServiceReportLoad, serviceReport, getDate, getServiceReport, downloadExcel } = useContext(AppContext);
	const [dateRange, setDateRange] = useState('');
	const tableRef = useRef(null);

	const getReport = (e) => {
		e.preventDefault();
		let start = e.target.start.value;
		let end = e.target.end.value;
		if (start !== "" && end !== "") {
			getServiceReport(start, end);
			setDateRange(`report_service_wise_from_${start}_to_${end}`);
		}
	}

	const formatExcel = () => {
		if (serviceReport !== undefined && serviceReport.bills !== undefined && Object.keys(serviceReport.bills).length > 0) {
			let data = [];
			Object.keys(serviceReport.bills).map(service => {
				data.push({
					'Service name': serviceReport.bills[service].service_name,
					'Total Count': serviceReport.bills[service].count,
					'SC': parseFloat(serviceReport.bills[service].akshaya_charge).toFixed(2),
					'TC': parseFloat(serviceReport.bills[service].gov_service_charge).toFixed(2),
					'Total': parseFloat(serviceReport.bills[service].total_amount).toFixed(2),
				});
			});
			return data;
		}
	}

	return (
		<div className="container-fluid">
			<div className="bgp grid4by6 br-3 p-2 align-items-center justify-content-between mb-2" >
				<div className='px-2'>
					{
						getServiceReportLoad ? (
							<span className="please-wait-spinner" ><Spinner animation="border" size="sm" /> Please wait...</span>
						) : (
							<span>Service wise report</span>
						)
					}
				</div>
				<Form onSubmit={getReport} >
					<Row>
						<Col xs={12} sm={4} md={4} >
							<InputGroup className="br-3">
								<InputGroup.Text className="br-3" id="inputGroup-sizing-default">From</InputGroup.Text>
								<Form.Control name="start" type="date" defaultValue={getDate()} className="br-3" />
							</InputGroup>
						</Col>
						<Col xs={12} sm={4} md={4} >
							<InputGroup className="br-3">
								<InputGroup.Text className="br-3" id="inputGroup-sizing-default">To</InputGroup.Text>
								<Form.Control name="end" type="date" defaultValue={getDate()} className="br-3" />
							</InputGroup>
						</Col>
						<Col xs={12} sm={4} md={4} className="d-grid" >
							<Button type="submit" className="btn-t1-r br-3" >Get Report</Button>
						</Col>
					</Row>
				</Form>
			</div>
			{
				serviceReport !== undefined && serviceReport.bills !== undefined && Object.keys(serviceReport.bills).length > 0 ? (
					<div className='d-flex justify-content-end align-items-center mb-2 gap-2' >
						<span>Download</span>
						<Button className="br-1" onClick={() => {
							downloadExcel(formatExcel(), `${dateRange}.xlsx`);
						}} size='sm' variant='success' ><i className='bi bi-download' ></i> Excel</Button>
						<Button onClick={() => {
							generatePDF(tableRef, { filename: `${dateRange}.pdf` });
						}} size='sm' className='br-1' variant='success' ><i className='bi bi-download' ></i> Pdf</Button>
						<ReactToPrint
							trigger={() => <Button className='br-1' variant='success' size='sm'><i className="bi bi-printer"></i> Print</Button>}
							content={() => tableRef.current}
						/>
					</div>
				) : null
			}
			<div ref={tableRef}>
				{

					serviceReport !== undefined ? (
						serviceReport.bills !== undefined ? (
							Object.keys(serviceReport.bills).length > 0 ? (
								<Table bordered className="tbl-bg-blue" >
									<thead>
										<tr>
											<th><span className="tp2" >Service name</span></th>
											<th className="text-end tp2" ><span>Total Count</span></th>
											<th className="text-end tp2" ><span>SC</span></th>
											<th className="text-end tp2" ><span>TC</span></th>
											<th className="text-end tp2" >Total</th>
										</tr>
									</thead>
									<tbody>
										{
											Object.keys(serviceReport.bills).map((service, s_i) => (
												<tr key={`servi_${s_i}`} >
													<td><span className="tp2">{serviceReport.bills[service].service_name}</span></td>
													<td className="tp2 text-end"><span>{serviceReport.bills[service].count}</span></td>
													<td className="tp2 text-end"><span>{parseFloat(serviceReport.bills[service].akshaya_charge).toFixed(2)}</span></td>
													<td className="tp2 text-end"><span>{parseFloat(serviceReport.bills[service].gov_service_charge).toFixed(2)}</span></td>
													<td className="tp2 text-end"><span>{parseFloat(serviceReport.bills[service].total_amount).toFixed(2)}</span></td>
												</tr>
											))
										}
										<tr>
											<td colSpan={2} className="text-end bgy" ><span className='f20' >Total</span></td>
											<td className="text-end bgy"><span className='f20' >{parseFloat(serviceReport.main.service_total).toFixed(2)}</span></td>
											<td className="text-end bgy"><span className='f20' >{parseFloat(serviceReport.main.transaction_total).toFixed(2)}</span></td>
											<td className="text-end bgy"><span className='f20' >{parseFloat(serviceReport.main.grand_total).toFixed(2)}</span></td>
										</tr>
									</tbody>
								</Table>
							) : 'Not found'
						) : ''
					) : 'Not found!'
				}
			</div>
		</div>
	)
}